import api from './api';
import types from './mutation-types';

export default {
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodeDetails(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateApcnInit_({ commit }) {
		commit(types.STATE_APCN_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateApcnSave_({ commit }, { key, value }) {
		commit(types.APCN_SAVE_INFO, { key, value });
	},
	setStatePwaApcnState_({ commit }, { key, value }) {
		commit(types.APCN_INFO, { key, value });
	},
	setBtnApprAuth_({ commit, state }) {
		//승인,기각,반려,권한
		let prcsStep = state.pwaApcnPopUp.prcsStep || '';
		let prcsRslt = state.pwaApcnPopUp.prcsRslt || '';

		let result = false;
		let result2 = false;

		//console.log('승인기각 화면권한은 있음>>>>>', prcsStep);
		if (prcsStep == '20') {
			//console.log('신청일경우에는 승인,기각,반려 할수있다.');
			result = true;
			if(prcsRslt == '40'){
				result2 = true;
			}
		} else {
			//신청상태가 아니면 승인 기각 반려를 할수가 없다.
			//console.log('신청상태가 아니면 승인 기각 반려를 할수가 없다.');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnApprAuth',
			value: result
		});
		commit(types.APCN_INFO, {
			key: 'btnApprAuth2',
			value: result2
		});
	},
	setBtnDelAuth_({ commit, state }, paramAuth) {
		//
		//신청버튼 권한
		let prcsStep = state.pwaApcnPopUp.prcsStep || '';
		let aplcDd = state.pwaApcnPopUp.aplcDd || '';
		let prcsRslt = state.pwaApcnPopUp.prcsRslt || '';
		let result = false;

		if (paramAuth) {
			//console.log('삭제화면권한은 있음');
			if (prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우');
				result = true;
			} else {
				//console.log('임시저장일경우에만 삭제가 가능하다.');
				result = false;
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnDelAuth',
			value: result
		});
	},
	setBtnApAuth_({ commit, state }, paramAuth) {
		//setDelAuth_
		//신청버튼 권한
		let prcsStep = state.pwaApcnPopUp.prcsStep || '';
		let aplcDd = state.pwaApcnPopUp.aplcDd || '';
		let prcsRslt = state.pwaApcnPopUp.prcsRslt || '';
		let result = false;

		if (paramAuth) {
			//console.log('화면권한은 있음', prcsStep);
			if (prcsStep == '' || prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우 신청버튼을 노출시킨다.');
				result = true;
			} else {
				//처리단계가 신청이며 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep != '20' && aplcDd != '') {
					//console.log('처리단계가 신청단계며  신청일자가 있을경우 신청버튼을 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnApAuth',
			value: result
		});
	},
	setBtnTsAuth_({ commit, state }, paramAuth) {
		//임시저장버튼 권한설정
		let prcsStep = state.pwaApcnPopUp.prcsStep || '';
		let aplcDd = state.pwaApcnPopUp.aplcDd || '';
		let prcsRslt = state.pwaApcnPopUp.prcsRslt || '';
		let result = false;

		if (paramAuth) {
			//console.log('화면권한은 있음');
			if (prcsStep == '' || prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우');
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep != '10') {
					//console.log('처리단계가 신청단계가 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnTsAuth',
			value: result
		});
	},
	getPwaApcnList_({ commit, state }) {
		//신청현황리스트조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;

		return api
			.getPwaApcnList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'excelDownLoadList',
						value: data?.body.selectSamPleExcelList || []
					});
					*/
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getPwaApcnPopList_({ commit, state }, pwaNoParam) {
		// PWA신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getPwaApcnPopList(pwaNoParam.pwaNo)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnPopUp',
						value: data?.body.resultVo || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnSwapPartsList',
						value: data?.body.resultList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'apprCommentList',
						value: data?.body.apprCommentList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'otherFeeList',
						value: data?.body.otherFeeList || []
					});

					/*컴포넌트 READONLY 처리 */
					commit(types.APCN_INFO, {
						key: 'readOnlyAuth',
						value: data.body.resultVo.prcsStep == '20' || data.body.resultVo.prcsStep == '30' ? true : false
					});

					commit(types.APCN_INFO, {
						key: 'backBtnOnlyAuth',
						value: data.body.resultVo.prcsStep == '30' && data.body.resultVo.prcsRslt == '10' ? true : false
					});

					//임시저정후 버튼권한 노출 처리 (임시저장, 신청 , 삭제)
					if (pwaNoParam.paramState === '10') {
						/*임시저장버튼 권한*/
						commit(types.APCN_INFO, {
							key: 'btnTsAuth',
							value: data.body.resultVo.prcsStep == '10' ? true : false
						});
						/*신청버튼 권한 */
						commit(types.APCN_INFO, {
							key: 'btnApAuth',
							value: data.body.resultVo.prcsStep == '10' ? true : false
						});
						/*삭제버튼 권한 */
						commit(types.APCN_INFO, {
							key: 'btnDelAuth',
							value: data.body.resultVo.prcsStep == '10' ? true : false
						});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}, //실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload({ params });
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	},
	savePwaApcnPopup_({ commit }, { formData }) {
		/*fromData 찍어보기*/
		return api
			.savePwaApcnPopup({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	delApcnSwapInfoList_({ commit }, param) {
		return api
			.delApcnSwapInfoList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnSwapPartsList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	apprDupCnt_({ commit, state }, payload) {
		//param,
		return api
			.apprDupCnt(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	saveStateAppr_({ commit, state }, payload) {
		//param,
		return api
			.saveStateAppr(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	deletePwaApcnPopup_({ commit }, param) {
		//('파람', param);
		return api
			.deletePwaApcnPopup(param)
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	//팝업 pwa 목록 조회
	getPopupPwaApcnList_({ commit, state }) {
		//신청현황리스트조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { popupSearchParams, pagingInfo } = state;
		//console.log('팝업으로 들어오니 state', state);

		return api
			.getPopupPwaApcnList({ popupSearchParams: popupSearchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	} /*PWA 팝업에서 캠페인번호 체크해서 있으면 캠페인 목록을 내려줌*/,
	chkPmcIdCampNo_({ commit }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.chkPmcIdCampNo(param)
			.then(data => {
				if (data.header.code === 0) {
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'chkPmcIdCampNoList',
						value: data?.body.result.cmpnNmList || []
					});
					*/
					//data = data.body.result.cmpnNmList
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//팝업 pwa 목록 조회
	getPwaUsedYear_({ commit, state }, param) {
		//신청현황리스트조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return api
			.getPwaUsedYear(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.APCN_INFO, {
						key: 'selUsedYear',
						value: data.body.rsVo.usePrd
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	chkPmcIdCampNo_({ commit }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.chkPmcIdCampNo(param)
			.then(data => {
				if (data.header.code === 0) {
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'chkPmcIdCampNoList',
						value: data?.body.result.cmpnNmList || []
					});
					*/
					//data = data.body.result.cmpnNmList
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
